/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { UPDATE_STATUS } from '@pages/PayoutListPage/apis/graphql';
import { notificationsPayoutListConfig } from '../../config/notifications.config';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/PayoutListPage/config/api.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';
import { useEventId } from '../../provider';
import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface UpdateStatusProps {
  id: string;
}

export interface IUpdateStatusMethods extends IPluginMethodMap {
  getUpdateStatusProps(args: any): Promise<any>;
}

export class UpdateStatusPlugin implements IAgentPlugin {
  readonly methods: IUpdateStatusMethods;

  constructor() {
    this.methods = {
      getUpdateStatusProps: this.getProps.bind(this),
    };
  }

  async getProps(args: UpdateStatusProps) {
    //return await this.getUpdateStatus(args);
    return { ...notificationsPayoutListConfig };
  }

  private async getUpdateStatus(args: any) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .query(UPDATE_STATUS, {
          input: {
            ...args,
          },
        })
        .toPromise();
      if (res?.data?.updateCycloneStatus?.status) {
        return {
          notification: notificationsPayoutListConfig?.updateStatus,
        };
      }
    } catch (err: any) {
      throw err;
    }
  }
  private formatTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          rowData: item,
          id: item?.policyId,
          vid: item?.purchaser?.vuid,
          status: item?.status,
          payout: item?.amount,
          policyNo: item?.policyNumber,
          name: `${item?.purchaser?.firstName} ${item?.purchaser?.lastName}`,
          email: item?.purchaser?.email,
          // image:item?.image,
          dateCreated: item?.policy?.purchasedAt
            ? moment(item?.policy?.purchasedAt).format('LLL')
            : '-',
          coverage: item?.policy?.coverage,
          premium: item?.policy?.premium,
          policyOption: `Policy Option ${item?.policy?.productDefination}`,
        };
      });
    return _rowData;
  }
}
